import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: SarinManS
 * id A0F96469-2C19-48B6-A054-3F48656CE24F
 * name chevron-right-circle
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-right-circle.svg
 * tags
 * - Arrow 
 */
export const ChevronRightCircleIcon = createSvgIcon(<><path d="M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,18L16,12L10,6L8.6,7.4L13.2,12L8.6,16.6L10,18Z" /></>, 'ChevronRightCircleIcon');
export default ChevronRightCircleIcon